import React from 'react';

const Copyright: React.FC = () => {
    return (
        <div className="flex flex-col items-center px-6 text-[#333] md:pt-10 pt-[73px] md:h-[500px] h-auto">
            <h1 className="md:text-5xl text-4xl md:text-6xl font-light mb-10">Copyright</h1>
            <div className="text-left text-[17px]">
                <h2 className="text-sm font-semibold mb-4">Copyright Notice</h2>
                <p className="mb-4">
                    All content and materials on this website and within the Ultimate Boards Product, including but not limited to the software, design, text, graphics, and documentation, are the exclusive property of UBOARDS INNOVATIONS LTD and are protected by copyright, trademark, and other intellectual property laws.
                </p>
                <p className="mb-4">
                    Unauthorized use, reproduction, distribution, or modification of any content is strictly prohibited without the express written permission of UBOARDS INNOVATIONS LTD.
                </p>
                <p className="mb-6">
                    For permission requests or inquiries, <strong>please contact us.</strong>
                </p>

                <button className="w-full md:w-auto border border-[#3A57FF] px-6 py-2 rounded-lg text-sm hover:bg-[#3A57FF] hover:text-white transition-all">
                    Contact Us
                </button>
            </div>
        </div>
    );
};

export default Copyright;
